import { useAuthStore } from "@/stores/auth";
import { useToaster } from "@/stores/toaster";
import { useLocalization } from "@/locales/localization";

export const useApiPing = function(){
  const host = process.env.VUE_APP_HOST;

  function ping(){
    return fetch(host + '/account/ping', {
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    }).then(processPing);
  }

  async function processPing(response){
    if(!response.ok){
      if(response.status == 401 || response.status == 403){
        const store = useAuthStore();
        store.resetLogin();
      }
    }
    return;
  }

  return { ping };
};

export const useApiClient = function () {
  const toaster = useToaster();
  const localization = useLocalization();

  const host = process.env.VUE_APP_HOST;

  function post(action, parameters) {
    return fetch(host + action, {
      method: "post",
      body: JSON.stringify(parameters),
      headers: {
        "content-type": "application/json",
        "Culture": localization.localeGet(),
      },
      credentials: "include",
    }).then(processResponse);
  }

  function get(action, parameters) {
    var url = new URL(host + action);
    if (parameters !== null) {
      for (let k in parameters) {
        url.searchParams.append(k, parameters[k]);
      }
    }

    return fetch(url, {
      method: "get",
      headers: {
        "content-type": "application/json",
        "Culture": localization.localeGet(),
      },
      credentials: "include",
    }).then(processResponse);
  }

  function file(action, parameters, fileName){
    var url = new URL(host + action);
    return fetch(url, { 
      method: "post",
      credentials: "include",
      body: JSON.stringify(parameters),
      headers: {
        "content-type": "application/json",
        "Culture": localization.localeGet(),
      }
    })
    .then(response => {
      if(!response.ok){
        processResponse(response);
        return;
      }

      return response.blob();
    });
  }

  function download(action, parameters, fileName) {
    var url = new URL(host + action);
    fetch(url, { 
      method: "post",
      credentials: "include",
      body: JSON.stringify(parameters),
      headers: {
        "content-type": "application/json",
        "Culture": localization.localeGet(),
      }
    })
    .then(response => response.blob())
    .then(blob => {
      const u = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = u;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(u);
    });
  }

  async function processResponse(response) {
    // a non-200 response code
    if (!response.ok) {

      if (response.status == 401 || response.status == 403) {
        const store = useAuthStore();
        store.resetLogin();
        return {
          ok: response.ok,
          data: null
        };
      }

      if (response.status == 400) {
        const json = await response.json();
        toaster.error(localization.t("errors.api." + json.code, { p: json.parameter }));
        return {
          ok: response.ok,
          data: null
        };
      }

      // Other unhandled exceptions
      const json = await response.json();
      toaster.error(localization.t("errors.api." + json.code, { p: json.parameter }));
      return {
        ok: response.ok,
        data: null
      };
    }

    var text = "";
    await response.text().then((body) => {
      text = body;
    });

    if (text.length == 0) {
      return { 
        ok: response.ok,
        data: null
      };
    }
    return {
      ok: response.ok,
      data: JSON.parse(text)
    };
  }

  return {
    post,
    get,
    file,
    download,
  };
};
